import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// lastUpdate zerado significa que o dispositivo nunca reportou
export function formatLastUpdate(lastUpdate: number): string {
  if (!lastUpdate) return 'nunca reportou';
  return formatDistanceToNow(lastUpdate, { addSuffix: true, locale: ptBR });
}
